export const replaceSpacesWithUnderscore = (input: string) => {
    return input.replace(/ /g, "_");
}